import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { RadioGroupProps } from './radio-group.component';
import RadioGroup from './radio-group.component';

export interface HfRadioGroupProps<TFieldValues extends FieldValues = FieldValues> extends RadioGroupProps {
  control: Control<TFieldValues>;
  name: string;
}

export default function HfRadioGroup<TFieldValues extends FieldValues = FieldValues>({
  id,
  control,
  name,
  label,
  data,
  value,
  textField,
  valueField,
  readOnly,
  required,
  orientation = 'VERTICAL',
  onChange,
  fieldValueConverter,
  disabled,
  labelStyles,
  archivedField,
  showSelectedArchivedOptions,
}: HfRadioGroupProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      defaultValue={value}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <RadioGroup
          id={id}
          name={name}
          label={label}
          value={value}
          error={error?.message}
          onChange={onChange}
          textField={textField}
          valueField={valueField}
          data={data}
          readOnly={readOnly}
          required={required}
          orientation={orientation}
          disabled={disabled}
          labelStyles={labelStyles}
          archivedField={archivedField}
          showSelectedArchivedOptions={showSelectedArchivedOptions}
        />
      )}
    />
  );
}
